<template>
  <b-modal class="modal-lg" id="importRulesModal" ref="import-rules-modal" :title="modal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="clearResponse()"  @hide="resetModal();refreshResults();resetExampleCSVdownload();">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'file-import']" size="1x" class="mr-2"/> {{ modal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <template v-if="responseType == 'importPage'">
        <h5 class="mt-2">{{t('downloadExample','downloadExample')}}</h5>
        <p>{{t('exampleCSVdownloadDescription', 'exampleCSVdownloadDescription')}}</p>
        <div class="d-flex justify-content-end">
          <template v-if="!exampleRequested">
            <button class="btn btn-primary" @click="requestCSV" :disabled="false">
              <fontAwesomeIcon :icon="['fa', 'file-download']" size="1x" class="mr-2"/>{{ t('requestExampleFile','requestExampleFile') }}
            </button>
          </template>
          <template v-else>
            <template v-if="(exampleCSVdownloadLink && exampleCSVdownloadLink.dataDownloadUrl) || exampleRequested">
              <a class="btn btn-success" target="_blank" :disabled="false" :href="downloadUrl" download>
                <fontAwesomeIcon :icon="['fa', 'file-download']" size="1x" class="mr-2"/>{{ t('downloadExampleFileLink', 'downloadExampleFileLink') }}
              </a>
            </template>
            <template v-else>
              <button type="button" class="btn btn-danger" disabled>
                <fontAwesomeIcon :icon="['fa', 'exclamation-triangle']" size="1x" class="mr-2"/>{{ t('downloadExampleGenerationFailed', 'downloadExampleGenerationFailed') }}
              </button>
            </template>
          </template>
        </div>
        <h5 class="mt-2">{{t('uploadFile','uploadFile')}}</h5>
        <b-form-file id="import-csv" class="mb-3" accept=".csv" v-model="importFile" required></b-form-file>
      </template>

      <template v-if="responseType == 'failedAtRow'">
        <h5>{{ t('columnCountError','columnCountError') }}</h5>
        <p v-if="getResponseInfo.failedAt && getResponseInfo.failedAt.length < 11">{{ t('failedAtRow', 'failedAtRow') }} {{getResponseInfo.failedAt}}</p>
        <p v-if="getResponseInfo.failedAt && getResponseInfo.failedAt.length >= 11">{{ t('failedAtMultipleRowsMsg', 'failedAtMultipleRowsMsg') }}</p>
        <p>{{ t('expectedColumnCount','expectedColumnCount') }} {{ getResponseInfo.expectedColumnCount }}</p>
      </template>

      <template v-if="responseType == 'validationError'">
        <h5>{{ t('ruleValidationError','ruleValidationError') }}</h5>
        <div>
          <template v-for="(vData, index) in getResponseInfo.validationData">
            <template v-if="vData.total_result == false">
              <p class="text-primary mt-2 mb-0">{{ t('ruleDataInRow','ruleDataInRow') }}: <span class="font-weight-bold">{{index}}</span></p>
              <span v-for="(result, indexNumber) in vData.individual_results" :key="index">
                <span class="mx-2">{{t(indexNumber, indexNumber)}}:
                  <span v-if="result == false" class="text-danger" ><fontAwesomeIcon :icon="['fa', 'times']" size="1x" class="mr-2"/></span>
                  <span v-else class="text-success"><fontAwesomeIcon :icon="['fa', 'check']" size="1x" class="mr-2"/></span>
                </span>
              </span>
            </template>
          </template>
        </div>
        <p class="mt-5">{{t('pleaseAmendYourFileAndReuploadIt', 'pleaseAmendYourFileAndReuploadIt')}}</p>
      </template>

      <template v-if="responseType == 'conflictsFound'">
        <h5>{{t('conflictsFound','conflictsFound')}}</h5>
        <p>{{t('noRulesHaveBeenImported', 'noRulesHaveBeenImported')}}</p>
        <div>
          <p v-for="(conflict, index) in getResponseInfo.rulesInConflict" :key="index">
            <span>{{t('ruleInRow','ruleInRow')}} {{index}} </span>
            <span>{{t('inConflictWithRuleInRow', 'inConflictWithRuleInRow')}} {{conflict}}</span>
          </p>
        </div>
        <p>{{t('pleaseAmendYourFileAndReuploadIt', 'pleaseAmendYourFileAndReuploadIt')}}</p>
      </template>

      <template v-if="responseType == 'conflictsFoundPleaseChooseToKeepOrDiscard'">
        <h5 class="text-center">{{t('conflictsFound','conflictsFound')}}</h5>
        <p class="text-center">{{t('pleaseChooseWhetherYouWantToKeepOrDiscardTheExistingRule','pleaseChooseWhetherYouWantToKeepOrDiscardTheExistingRule')}}</p>
        <b-table striped hover :items="getResponseInfo.currentRules" :fields="fields" :thead-class="'brand-color'">
          <template v-slot:head(id)="data">
            <span> {{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(customer_ref)="data">
            <span> {{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(customer_type)="data">
            <span> {{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(document_ref)="data">
            <span> {{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(document_type)="data">
            <span>{{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(invoice_type)="data">
            <span>{{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(document_value)="data">
            <span>{{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(batch_type)="data">
            <span>{{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(country)="data">
            <span>{{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(entity_code)="data">
            <span>{{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(entity)="data">
            <span>{{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(brand)="data">
            <span> {{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(duplicate_document)="data">
            <span> {{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(rule)="data">
            <span> {{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:head(enabled)="data">
            <span> {{ t(data.label, data.label) }}</span>
          </template>
          <template v-slot:cell(id)="data">
            {{data.item.id}}
          </template>
          <template v-slot:cell(customer_ref)="data">
            <template v-if="data.item.customer_ref && (data.item.customer_ref.length > 1)">
              {{data.item.customer_ref}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(customer_type)="data">
            <template v-if="data.item.customer_type && (data.item.customer_type.length > 1)">
              {{data.item.customer_type}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(document_ref)="data">
            <template v-if="data.item.document_ref && (data.item.document_ref.length > 1)">
              {{data.item.document_ref}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(document_type)="data">
            <template v-if="data.item.document_type && (data.item.document_type.length > 1)">
              {{data.item.document_type}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(invoice_type)="data">
            <template v-if="data.item.invoice_type">
              {{data.item.invoice_type}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(document_value)="data">
            <template v-if="data.item.document_value && (data.item.document_value.length > 1)">
              {{data.item.document_value}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(batch_type)="data">
            <template v-if="data.item.batch_type && (data.item.batch_type.length > 1)">
              {{data.item.batch_type}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(country)="data">
            <template v-if="data.item.country && (data.item.country.length > 1)">
              {{data.item.country}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(entity)="data">
            <template v-if="data.item.entity && (data.item.entity.length > 1)">
              {{data.item.entity}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(entity_code)="data">
            <template v-if="data.item.entity_code && (data.item.entity_code.length > 1)">
              {{data.item.entity_code}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(brand)="data">
            <template v-if="data.item.brand_name && (data.item.brand_name.length > 1)">
              {{data.item.brand_name}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(duplicate_document)="data">
            <template v-if="data.item.duplicate_document">
              {{t('yes', 'yes')}}
            </template>
            <template v-else>
              {{t('no', 'no')}}
            </template>
          </template>
          <template v-slot:cell(rule)="data">
            <template v-if="data.item.rule">
              {{data.item.rule}}
            </template>
            <template v-else>
              {{t('all', 'all')}}
            </template>
          </template>
          <template v-slot:cell(enabled)="data">
            {{data.item.enabled}}
          </template>
          <template v-slot:row-details="row">
            <b-card>
              <p class="text-center">{{t('conflictsWith', 'conflictsWith')}}</p>
              <b-table striped hover :items="row.item.conflicting" :fields="fields" :thead-class="'brand-color'">
                <template v-slot:head(id)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(customer_ref)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(customer_type)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(document_ref)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(document_type)="data">
                  <span>{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(document_value)="data">
                  <span>{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(batch_type)="data">
                  <span>{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(country)="data">
                  <span>{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(entity_code)="data">
                  <span>{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(entity)="data">
                  <span>{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(brand)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(duplicate_document)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(rule)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(enabled)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:cell(id)="data">
                  -
                </template>
                <template v-slot:cell(customer_ref)="data">
                  <template v-if="data.item.customer_ref && (data.item.customer_ref.length > 1)">
                    {{data.item.customer_ref}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(customer_type)="data">
                  <template v-if="data.item.customer_type && (data.item.customer_type.length > 1)">
                    {{data.item.customer_type}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(document_ref)="data">
                  <template v-if="data.item.document_ref && (data.item.document_ref.length > 1)">
                    {{data.item.document_ref}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(document_type)="data">
                  <template v-if="data.item.document_type && (data.item.document_type.length > 1)">
                    {{data.item.document_type}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(document_value)="data">
                  <template v-if="data.item.document_value && (data.item.document_value.length > 1)">
                    {{data.item.document_value}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(batch_type)="data">
                  <template v-if="data.item.batch_type && (data.item.batch_type.length > 1)">
                    {{data.item.batch_type}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(country)="data">
                  <template v-if="data.item.country && (data.item.country.length > 1)">
                    {{data.item.country}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(entity)="data">
                  <template v-if="data.item.entity && (data.item.entity.length > 1)">
                    {{data.item.entity}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(entity_code)="data">
                  <template v-if="data.item.entity_code && (data.item.entity_code.length > 1)">
                    {{data.item.entity_code}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(brand)="data">
                  <template v-if="data.item.brand_name && (data.item.brand_name.length > 1)">
                    {{data.item.brand_name}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(duplicate_document)="data">
                  <template v-if="data.item.duplicate_document">
                    {{t('yes', 'yes')}}
                  </template>
                  <template v-else>
                    {{t('no', 'no')}}
                  </template>
                </template>
                <template v-slot:cell(rule)="data">
                  <template v-if="data.item.rule">
                    {{data.item.rule}}
                  </template>
                  <template v-else>
                    {{t('all', 'all')}}
                  </template>
                </template>
                <template v-slot:cell(enabled)="data">
                  {{data.item.enabled}}
                </template>
              </b-table>
              <div class="col-12 row justify-content-end">
                <button class="btn btn-danger mt-2" type="button" @click="importRules({type: 'discardExisting', rowId: row.item.id, rowData: row.item.conflicting})">
                  <fontAwesomeIcon :icon="['fa', 'times']" size="1x" class="mr-2"/>{{ t('discardExistingRuleButtonText', 'discardExistingRuleButtonText')}}
                </button>
              </div>
            </b-card>
          </template>
        </b-table>
        <div class="col-12 text-right">
          <button class="btn btn-success mt-2 mr-3" type="button" @click="cancelForm()">
            <fontAwesomeIcon :icon="['fa', 'check']" size="1x" class="mr-2"/>{{ t('keepExistingRulesButtonText', 'keepExistingRulesButtonText')}}
          </button>
          <button class="btn btn-danger mt-2" type="button" @click="importRules({ type: 'discardAll' })">
            <fontAwesomeIcon :icon="['fa', 'times']" size="1x" class="mr-2"/>{{ t('discardAllRuleButtonText', 'discardAllRuleButtonText')}}
          </button>
        </div>
      </template>

      <template v-if="responseType == 'importRulesSuccess' || responseType == 'discardAllRulesSuccess'">
        <h5>{{t('ruleImportSuccess','ruleImportSuccess')}}</h5>
        <p>{{t('imported','imported')}}
          {{getResponseInfo.rulesInserted}}
          <span v-if="getResponseInfo.rulesInserted > 1">{{t('rules','rules')}}</span>
          <span v-else>{{t('rule','rule')}}</span>
        </p>
      </template>
      <div ref="message" v-if="showMessage">
        <ResponseInfo class="mt-3" v-if="((getResponseInfo.responseName == 'importModal') && (getResponseInfo.status == 'error'))"></ResponseInfo>
      </div>
    </template>

    <template slot="modal-footer" slot-scope="{ cancel, close }">
      <template v-if="responseType == 'importPage'">
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
        </button>
        <template v-if="modal.modalData">
          <div v-if="buttonIsBusy">
            <div class="sk-folding-cube">
              <div class="sk-cube1 sk-cube"></div>
              <div class="sk-cube2 sk-cube"></div>
              <div class="sk-cube4 sk-cube"></div>
              <div class="sk-cube3 sk-cube"></div>
            </div>
          </div>
          <button v-if="!buttonIsBusy" aria-label="ImportRules" data-dismiss="modal" class="btn btn-primary" type="button" @click="importRules()">
            <fontAwesomeIcon :icon="['fa', 'file-import']" size="1x" class="mr-2"/>{{ t('importRulesButtonText', 'importRulesButtonText')}}
          </button>
        </template>
      </template>
      <template v-else>
        <button class="btn btn-secondary" type="button" @click="close()">
          <fontAwesomeIcon :icon="['fa', 'times']" class="text-light mr-2"/>{{ t('closeButtonText', 'closeButtonText')}}
        </button>
      </template>

    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
//import { backendUrl } from '@/helpers/backendUrl.js'
import { awsUrl } from '@/helpers/awsUrl.js'

export default {
  name: 'import_rules_modal',
  inject: [
    'modal',
    'resetModal',
    'refreshResults',
    'clearResponse'
  ],
  data () {
    return {
      buttonIsBusy: false,
      exampleRequested: false,
      columns: [],
      ruleData: [],
      importFile: null,
      showMessage: true
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    fields() {
      return this.$store.getters['sendExceptionsStore/getExceptionsColumnsForImport']
    },
    //NS-9837 download URL generation amended with backendUrl function RR
    //NS-9837 download URL generation amended with awsUrl function RR
    downloadUrl() {
      let urlBit = ''
      if(this.exampleCSVdownloadLink && this.exampleCSVdownloadLink.dataDownloadUrl) {
        urlBit = this.exampleCSVdownloadLink.dataDownloadUrl
      }

      //return backendUrl() + urlBit
      return awsUrl() + urlBit
    },
    exampleCSVdownloadLink() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionsExampleCSV']
    },
    responseType() {
      let response = this.getResponseInfo
      let responsesWithMessage = ['missingFile', 'notAcsvFile', 'fileIsEmptyOrCorrupted', 'fileImportError',
      'addRuleError', 'addRuleDataError', 'emptyRuleColumns', 'ruleColumnForRuleNumberIsMissing', 'ruleColumnDuplicateFound',
      'noneOfTheRuleColumnsCanBeEmpty']

      if(!response.key) {
          return 'importPage'
      } else {
          if(responsesWithMessage.includes(response.key)) {
            this.showMessage = true
            return 'importPage'
          } else {
            this.showMessage = false
            return response.key
          }
      }
    }
  },
  methods: {
    requestCSV() {
      this.exampleRequested = true
      this.$store.dispatch('sendExceptionsStore/getSendExceptionsExampleCSV')
    },
    importRules(importType = { type: 'normal' } ) {
      if(importType && !importType.type) {
        importType.type = 'normal'
      }
      
      let formData = new FormData();
      formData.append('rulesCSV', this.importFile)
      formData.append('ruleColumns', this.columns)
      formData.append('importType', importType.type)

      if(importType.type != 'normal') {
        if(importType.type == 'discardAll') {
          console.log(this.getResponseInfo.currentRules)
          if(this.getResponseInfo && this.getResponseInfo.currentRules) {
            formData.append('discardRules', JSON.stringify(this.getResponseInfo.currentRules))
            let newData = this.getResponseInfo.currentRules
            let newRules = []
            newData.forEach(rule => {
              newRules.push(rule.conflicting[0])
            })
            formData.append('rowData', JSON.stringify(newRules))
          }
        } else {
          formData.append('rowId', importType.rowId)
          formData.append('rowData', JSON.stringify(importType.rowData))
        }
      }

      this.$store.dispatch('sendExceptionsStore/importSendExceptions', formData)
      .then(answer => {
        let response = this.getResponseInfo
        if(response.status == 'success') {
          this.refreshResults()
        }
        if((response.status == 'error') && this.showMessage){
          this.$refs['message'].scrollIntoView()
        }
        if(answer.key != 'conflictsFoundPleaseChooseToKeepOrDiscard') {
          this.importFile = null
        }
        
      })
    },
    cancelForm() {
      this.$refs['import-rules-modal'].hide()
    },
    resetExampleCSVdownload() {
      this.exampleRequested = false
      let filename = ''
      if(this.exampleCSVdownloadLink && (this.exampleCSVdownloadLink.filename != undefined)) {
          filename = this.exampleCSVdownloadLink.filename
      }
      this.$store.dispatch('sendExceptionsStore/destroySendExceptionsCSV', filename).then(
        () => {
          this.$store.commit('sendExceptionsStore/setSendExceptionsExampleCSV', false)
        }
      )
    }
  },
  created() {
    this.$store.dispatch('sendExceptionsStore/getExceptionsColumnsForImport')
    this.exampleRequested = false
    this.clearResponse()
    this.columns = []
  },
  components:{
    ResponseInfo
  }
}
</script>

<style scoped>
.modal-open #importRulesModal___BV_modal_outer_ >>> .modal-dialog{
  display: flex !important;
  justify-content: center !important;
}
.modal-open #importRulesModal___BV_modal_outer_ >>> .modal-content{
  min-width: 850px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #importRulesModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 600px;
  overflow-y: scroll;
}
/*TABLE*/
.table-responsive  >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}
</style>
